
import get from 'lodash/get';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

export default {
  components: {
    CollapseTransition,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bodyHTML: [],
      desktopStopLine: 1000, // Show all initially
      mobileStopLine: 1000,
      showMore: false,
      isOpen: false,
      hasParsed: false,
    };
  },
  watch: {
    text() {
      if (process.client) {
        this.parseBody();
      }
    },
  },

  mounted() {
    this.parseBody();
    this.$nextTick(() => {
      this.calcHeight();
    });
  },
  methods: {
    parseBody() {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.text;
      const parts = tempDiv.children || [];

      const bodyHTML = [];
      for (let i = 0; i < parts.length; i += 1) {
        bodyHTML.push(parts[i].outerHTML);
      }
      this.bodyHTML = bodyHTML;
    },
    hasMore(type) {
      const { length } = this.bodyHTML;
      const stopLine = (type === 'desktop') ? this.desktopStopLine : this.mobileStopLine;

      return length - stopLine > 0;
    },
    clickMore() {
      this.showMore = !this.showMore;
    },
    calcHeight() {
      const MAX_HEIGHT_DESKTOP = 400;
      const MAX_HEIGHT_MOBILE = 200;

      // Can get more fancy if we want to check for window width and window resize
      const childrenDesktop = get(this, ['$refs', 'founderBody', 'children', 0], {});
      const childrenMobile = get(this, ['$refs', 'founderBody', 'children', 1], {});

      const children = childrenDesktop.clientHeight
        ? childrenDesktop.children
        : childrenMobile.children;

      if (!(children && children.length)) return;

      let currentHeight = 0;
      let desktopStopLine = 1;
      let mobileStopLine = 1;

      for (let i = 0; i < children.length; i += 1) {
        let continueLoop = false;

        currentHeight += children[i].scrollHeight;

        if (currentHeight <= MAX_HEIGHT_DESKTOP) {
          continueLoop = true;
          desktopStopLine += 1;
        }

        if (currentHeight <= MAX_HEIGHT_MOBILE) {
          continueLoop = true;
          mobileStopLine += 1;
        }

        if (!continueLoop) {
          break;
        }
      }

      this.desktopStopLine = desktopStopLine;
      this.mobileStopLine = mobileStopLine;

      // Make sure data has been updated before removing temp hidden style
      this.$nextTick(() => {
        this.hasParsed = true;
      });
    },
  },
};
